@import '../../../common/facets/facet-common.pcss';
